<template>
  <div class="in container" v-if="order">

    <section class="masthead masthead--inner">
      <div class="in">
        <div class="masthead__slide" style="background: url('../../../../../../static/styles/mailkit/img/banner.jpg') center center / cover no-repeat; width: 100%; display: inline-block;">
          <div class="masthead__caption">
            <h3>Almost there!<br>You have found the machine that is right for you, now you are just a step away from your future savings</h3>
          </div>
        </div>
      </div>
    </section>
    <section class="fullText">
      <div class="in container">
        <h4 style="font-size: 1.8rem;color: #0a70e3;font-weight:600">Your Order</h4>
        <p>Please see the details of your chosen solution below. If you would like to progress please submit your order, a member of our support team will be in contact within 1 hour to arrange the necessary paperwork.</p>
        <div class="btnBlock">
        </div>
      </div>
    </section>

    <hr style="margin-bottom: 20px;">

    <div style="position: relative;">

      <div class="btn btn--blockPrimary" style=" background-color: transparent;padding-left:0;cursor:pointer;color:rgb(43, 114, 220)" @click="backToResults">
        <i class="fa fa-chevron-left" style="margin-right:10px; cursor:pointer;"></i>Back to results
      </div>

      <div class="row">
        <div class="your-details box">
          <h3>Your details</h3>
          <table>
            <tr>
              <th>Company name: </th>
              <td> {{ order.quote.user.company_name }}</td>
            </tr>
            <tr>
              <th>Address:</th>
              <td>
                {{ order.quote.office_address }}<br>
                <span style="text-transform: uppercase;">
                  {{ order.quote.office_postcode }}
                </span>
              </td>
            </tr>
            <tr>
              <th>Contact name:</th>
              <td>{{ order.quote.user.name }}</td>
            </tr>
            <tr>
              <th>Email:</th>
              <td>{{ order.quote.user.email }}</td>
            </tr>
            <tr>
              <th>Phone:</th>
              <td>{{ order.quote.user.contact_phone }}</td>
            </tr>
          </table>
        </div>
        <div class="machine-details box">

          <div class="machine-image" style="text-align:center">
            <h3>Machine details</h3>
            <img :src="getMachineImage()" alt="">
            <div class="btn btn--blockPrimary" style="cursor:pointer; background-color: transparent;color:rgb(43, 114, 220);margin-top:20px" @click="toggle('showSpecification')">
              Specification summary
              <i class="fa fa-chevron-up" style="margin-left:10px;" v-if="showSpecification"></i>
              <i class="fa fa-chevron-down" style="margin-left:10px;" v-if="!showSpecification"></i>
            </div>
          </div>

        </div>
      </div>
      <div class="row">
        <div class="box order-details">
          <div class="border">
            <h3>Order details</h3>
            <h4 class="text text-blue">{{ isPurchase() ? 'Purchase' : term() + ' year lease' }} investment option</h4>

            <div v-if="order.quote.uses_franking_machine" class="options" style="text-align: center;">
              <div v-if="!isPurchase()">
                <h4 class="text-blue blue" style="font-weight:700">Quarterly investment <span v-html="makeNumberWithPound(this.getTotalEffectiveCostValue(term() - 1))" style="font-weight:700;font-size:1.4rem;"></span><span style="font-weight:700;font-size:1.4rem;" v-if="parseFloat(order.costs.savings_over_term.lease[term() - 1]) < 0">*</span><span style="font-weight:700;font-size:1.4rem;" v-if="parseFloat(order.costs.savings_over_term.lease[term() - 1]) >= 0">^^</span></h4>

                <h5 class="red" style="font-weight:700">
                        <span style="font-size: 1.1rem;line-height:2rem;">
                          <span v-if="order.costs.annual_savings_available.lease[term() - 1] > 0" style="font-weight:700">Annual saving: <span v-html="makeNumberWithPound(order.costs.annual_savings_available.lease[term() - 1])" style="font-weight:700"></span>**<br></span>
                          <span v-if="order.costs.savings_over_term.lease[term() - 1] > 0" style="font-weight:700">Total savings over term: <span v-html="makeNumberWithPound(order.costs.savings_over_term.lease[term() - 1])" style="font-weight:700"></span>**</span>
                        </span>
                </h5>
              </div>

              <div v-else class="options">
                <h4 class="text-blue blue" style="font-weight:700">First year cost <span v-html="makeNumberWithPound(order.costs.total_equipment_and_service_cost.purchase)" style="font-weight:700;font-size:1.4rem;"></span>*</h4>
                <h4 class="text-blue blue" style="font-weight:700">Year 2 cost <span v-html="makeNumberWithPound(order.costs.total_service_cost.purchase)" style="font-weight:700;font-size:1.4rem;"></span></h4>

                <h5 class="red" style="font-weight:700">
                        <span>
                          <span v-if="order.costs.savings_over_term > 0" style="font-weight:700">Savings over 5 years: <span v-html="makeNumberWithPound(order.costs.savings_over_term)" style="font-weight:700"></span>**</span>
                        </span>
                </h5>
              </div>

              <br><br>

              <div style="text-align: center;color: black;padding: 10px 0px;text-transform: none; line-height: 2rem;">
                <b class="red" style="font-weight:bold;font-size: 1.1rem;">
                  ^ Includes rental, service, invoice fees, insurance fees, recrediting fees and consumables where applicable<br>
                </b>

                <template v-if="(isPurchase() && order.costs.annual_savings_available.purchase > 0) || !isPurchase() && order.costs.annual_savings_available.lease[term() - 1] > 0">
                  <b class="blue" style="font-weight:bold;font-size: 1.1rem;">^^ Includes, rental/purchase, service, consumables and recredit fee costs<br></b>
                </template>

                <template v-if="(isPurchase() && order.costs.annual_savings_available.purchase < 0) || !isPurchase() && order.costs.annual_savings_available.lease[term() - 1] < 0">
                  <b class="blue" style="font-weight:bold;font-size: 1.1rem;">* Includes both rental/purchase and service costs.<br></b>
                </template>

                <b class="red" style="font-weight:bold;font-size: 1.1rem;" v-if="(isPurchase() && order.costs.savings_over_term.purchase > 0) || !isPurchase() && order.costs.savings_over_term.lease[term() - 1] > 0">
                  ** Includes anticipated savings on ink, labels, postage and machine rental/service costs<br>
                </b>
                <br>
                <b class="blue" style="font-weight:bold;font-size: 1.1rem;">Please note: Additional costs may apply for delivery, installation and administration. Consumable spend includes estimated ink, labels and recrediting charges</b>

              </div>
            </div>

            <div v-if="!order.quote.uses_franking_machine" class="options">
              <div v-if="!isPurchase()" style="text-align:center;">
                <h4 class="blue text-blue" style="font-weight:700">Quarterly investment <span v-html="$root.mnwp(this.getTotalEffectiveCostValue(term() - 1))" style="font-weight:700;font-size:1.4rem;"></span>*</h4>

                <h5 class="red text-red" style="font-weight:700;font-size: 1.1rem;line-height:2rem;">
                  <span>
                    <span v-if="order.costs.postage_savings > 0" style="font-weight:700">Annual postage savings: <span v-html="makeNumberWithPound(order.costs.postage_savings)" style="font-weight:700"></span>**<br></span>
                    <span v-if="getPostageSavingsOverTermValue(term() - 1) > 0" style="font-weight:700">Total postage savings over term: <span v-html="makeNumberWithPound(getPostageSavingsOverTermValue(term() - 1))" style="font-weight:700"></span>**</span>
                  </span>
                </h5>
              </div>

              <div v-else style="text-align:center;" class="options">
                <h4 class="text-blue blue" style="font-weight:700">First year cost <span v-html="makeNumberWithPound(order.costs.total_equipment_and_service_cost.purchase)" style="font-weight:700;font-size:1.4rem;"></span>*</h4>
                <h4 class="text-blue blue" style="font-weight:700">Year 2 cost <span v-html="makeNumberWithPound(order.costs.total_service_cost.purchase)" style="font-weight:700;font-size:1.4rem;"></span></h4>

                <h5 class="red" style="font-weight:700">
                        <span>
                          <span v-if="order.costs.postage_savings_over_term > 0" style="font-weight:700">Postage savings over 5 years: <span v-html="makeNumberWithPound(order.costs.postage_savings_over_term)" style="font-weight:700"></span>**</span>
                        </span>
                </h5>
              </div>

              <br><br>

              <div style="text-align: center;color: black;padding: 10px 0px;text-transform: none">
                <b class="red" style="font-weight:bold;font-size: 1.1rem;" v-if="order.quote.uses_franking_machine">
                  ^ Includes rental, service, invoice fees, insurance fees, recrediting fees and consumables where applicable<br>
                </b>

                <b class="red" style="font-weight:bold;font-size: 1.1rem;" v-if="!order.quote.uses_franking_machine && order.costs.postage_savings > 0">
                  ** Based on the daily volume of letters provided. Assumes all mail processed is letter format (0-100g).<br><br>
                </b>

                <template v-if="order.quote.uses_franking_machine && options[0].savings_over_term > 0">
                  <b class="blue" style="font-weight:bold;font-size: 1.1rem;">^^ Includes, rental/purchase, service, consumables and recredit fee costs<br></b>
                </template>

                <template v-if="(order.quote.uses_franking_machine && options[0].savings_over_term < 0) || !order.quote.uses_franking_machine">
                  <b class="blue" style="font-weight:bold;font-size: 1.1rem;">* Includes both rental/purchase and service costs.<br></b>
                </template>

                <b class="red" style="font-weight:bold;font-size: 1.1rem;" v-if="order.quote.uses_franking_machine && savingsOverTermPositive > 0">
                  ** Includes anticipated savings on ink, labels, postage and machine rental/service costs<br>
                </b>
                <br>
                <b class="blue" style="font-weight:bold;font-size: 1.1rem;" v-if="order.quote.uses_franking_machine">Please note: Additional costs may apply for delivery, installation and administration. Consumable spend includes estimated ink, labels and recrediting charges</b>
                <b class="blue" style="font-weight:bold;font-size: 1.1rem;" v-if="!order.quote.uses_franking_machine">Please note: Additional costs may apply for delivery, installation and administration.</b>
                <!--All costs and savings have been calculated using the full costs associated with your existing arrangement. This includes any ink and label costs, postage top up fees, invoicing and insurance fees you currently pay.<br><br>-->
                <!--Please note: An additional one off set up and delivery fee of £120 applies to all orders-->

              </div>
            </div>


<!--            <h4 class="text text-blue">{{ !isPurchase() ? 'Total quarterly investment:' : 'First year cost:' }} <span v-html="$root.mnwp(this.getTotalEffectiveCostValue(term() - 1))"></span>*</h4>-->

<!--            <div v-if="order.quote.uses_franking_machine" class="text text-blue">-->
<!--                <h5 class="blue" style="font-weight:700">Year 2 service cost <span v-html="$root.mnwp(order.costs.total_service_cost)" style="font-weight:700;font-size:1.4rem;"></span></h5>-->
<!--            </div>-->

<!--            <h4 class="text-red">-->

<!--              <span v-if="(this.getSwitchAndSaveValue(term() - 1) > 0 && !term())" style="font-weight:700">Year 1 saving:</span>-->
<!--              <span v-if="(this.getSwitchAndSaveValue(term() - 1) <= 0 && !term())" style="font-weight:700">Year 1 investment:</span>-->
<!--              <span v-if="this.getSwitchAndSaveValue(term() - 1) > 0 && term()" style="font-weight:700">Annual saving:</span>-->
<!--              <span v-if="this.getSwitchAndSaveValue(term() - 1) <= 0 && term()" style="font-weight:700">Annual investment:</span>-->
<!--              <span v-if="this.getSwitchAndSaveValue(term() - 1) > 0 && !term()" v-html="makeNumberWithPound(this.getSwitchAndSaveValue(term() - 1)) + '**'" style="font-weight:700"></span>-->
<!--              <span v-if="this.getSwitchAndSaveValue(term() - 1) <= 0 && !term()" v-html="makeNumberWithPound(Math.abs(this.getSwitchAndSaveValue(term() - 1))) + '**'" style="font-weight:700"></span>-->
<!--              <span v-if="this.getSwitchAndSaveValue(term() - 1) > 0 && term()" v-html="makeNumberWithPound(this.getEffectiveAnnualSaving(term()-1)) + '**'" style="font-weight:700"></span>-->
<!--              <span v-if="this.getSwitchAndSaveValue(term() - 1) <= 0 && term()" v-html="makeNumberWithPound(Math.abs(this.getEffectiveAnnualSaving(term()-1))) + '**'" style="font-weight:700"></span>-->

<!--            </h4>-->

<!--            <h4 class="text-red">-->
<!--              <span v-if="this.getSavingOverTermValue(term() - 1) > 0" style="font-weight:700">Switch and save:</span>-->
<!--              <span v-if="this.getSavingOverTermValue(term() - 1) <= 0" style="font-weight:700">Total effective cost:</span>-->
<!--              <span v-if="this.getSavingOverTermValue(term() - 1) > 0" v-html="makeNumberWithPound(this.getSavingOverTermValue(term() - 1)) + '**'" style="font-weight:700"></span>-->
<!--              <span v-if="this.getSavingOverTermValue(term() - 1) <= 0" v-html="makeNumberWithPound(Math.abs(this.getSavingOverTermValue(term() - 1))) + '**'" style="font-weight:700"></span>-->
<!--            </h4>-->
<!--            <h4 style="margin-top:0px !important;">-->
<!--              <span v-if="term()" class="text-red" style="color: #b50a78; font-weight:500; font-size:1.2rem">Calculated based on the total lease term</span>-->
<!--              <span v-if="!term()" class="text-red" style="color: #b50a78; font-weight:500; font-size:1.2rem">Calculated based on a 5 year term</span>-->
<!--            </h4>-->

            <div style="text-align: center;color: black;padding: 10px 0px;text-transform: none">
<!--              54-->
              <!--All costs and savings have been calculated using the full costs associated with your existing arrangement. This includes any ink and label costs, postage top up fees, invoicing and insurance fees you currently pay.<br><br>-->
              <!--Please note: An additional one off set up and delivery fee of £120 applies to all orders-->

            </div>
          </div>
        </div>
        <div class="box specification-summary">
          <div class="border">
            <h3 data-v-57650d4a="">Complete your order</h3>
            <div>
              <specification v-if='order' v-bind:class="{ isActive: showSpecification }" :order="order"></specification>
            </div>


            <hr>
            <h5>Let us keep you up to date</h5>
            <div class="frmInline row contact-options" style="justify-content:center;">
              <div>
                <input type="checkbox" @click="toggleAll('contact_by_email')" class="contact_by_email_spec" v-model="contact_by_email"/><br><span>Email</span>
              </div>
              <div>
                <input type="checkbox" @click="toggleAll('contact_by_phone')" class="contact_by_phone_spec" v-model="contact_by_phone"/><br><span>Phone</span>
              </div>
              <div>
                <input type="checkbox" @click="toggleAll('contact_by_post')" class="contact_by_post_spec" v-model="contact_by_post"/><br><span>Mail</span>
              </div>
              <div>
                <input type="checkbox" @click="toggleAll('contact_by_sms')" class="marketing contact_by_sms_spec" v-model="contact_by_sms"><br><span>SMS</span>
              </div>
            </div>
            <hr>
            <p class="regular-para">
              *Disclaimer: Although we make every effort to make sure the accuracy
              of our data we cannot guarantee 100% accuracy, with this in mind
              you should also ratify the information and ensure its to your satisfaction.<br>
              <a href="https://themailingexpert.com/disclaimer/" target="_blank">Click to see full disclaimer</a>
            </p>

            <div class="frmInline" style="text-align:left;">
              <div class="agreementWrapper">
                <input type="checkbox" @click="terms_and_agreement=!terms_and_agreement" v-model="terms_and_agreement" class="terms_and_agreement"/><span>I have read and understood the <a href="https://themailingexpert.com/terms-and-conditions/" target="_blank">terms and conditions</a>.</span>
              </div>
            </div>

            <div style="text-align:center;">
              <div class="btn btn-gradient" @click="submitOrder">
                Submit Order
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="mb-200"></div>
  </div>
</template>
<script>
  import Specification from './specification/Specification.vue'
  import {mapState} from 'vuex'

  export default {
    components: {
      Specification
    },
    created() {
      let order_id = this.$route.params.id
      this.load(order_id)
      this.updateContactPreferences()
    },
    data() {
      return {
        order: null,
        showSpecification: false,
        contact_by_email: false,
        contact_by_phone: false,
        contact_by_post: false,
        contact_by_sms: false,
        terms_and_agreement: false
      }
    },
    computed: {
      ...mapState('QuoteForm', ['step2']),
      preferences_email: {
        get() {
          return this.step2.preferences_email
        }
      },
      preferences_phone: {
        get() {
          return this.step2.preferences_phone
        }
      },
      preferences_mail: {
        get() {
          return this.step2.preferences_mail
        }
      },
      preferences_sms: {
        get() {
          return this.step2.preferences_sms
        }
      }
    },
    methods: {
      isChecked(item) {
        return item === true
      },
      getContacts() {
        return {
          contact_by_email: this.isChecked(this.contact_by_email),
          contact_by_phone: this.isChecked(this.contact_by_phone),
          contact_by_post: this.isChecked(this.contact_by_post),
          contact_by_sms: this.isChecked(this.contact_by_sms)
        }
      },
      load(id = null) {
        this.axios.get('orders/' + id).then(response => {
          this.order = response.data

          if (this.order) {
            if (this.order.contact_by_sms) {
              this.toggleAll('contact_by_sms', true)
            }
            if (this.order.contact_by_post) {
              this.toggleAll('contact_by_post', true)
            }
            if (this.order.contact_by_phone) {
              this.toggleAll('contact_by_phone', true)
            }
            if (this.order.quote.contact_by_email) {
              this.toggleAll('contact_by_email', true)
            }
          }

          this.$forceUpdate()
        })
      },
      term() {
        return this.order.investment_option
      },
      isPurchase() {
        return this.term() === 0
      },
      makeNumberWithPound(number) {
        if (number < 0) {
          return '-&pound;' + _n(Math.abs(number))
        }
        return '&pound;' + _n(number)
      },
      getValueByTerm(item) {
        let value = '-';
        if (this.isPurchase()) {
          value = item.purchase
        } else {
          value = item.lease[this.term()]
        }
        if (value) {
          value = value.toFixed(2)
        }
        return value
      },
      getMachineImage() {
        return '/static/styles/mailkit/img/printers/' + this.order.costs.printer.image_url
      },
      toggle(item, value = null) {
        if (value !== null) {
          this[item] = value
        } else {
          this[item] = !this[item]
        }
      },
      toggleRadio(name, value = null) {
        if (this[name] || value === true) {
          $('input.' + name + '_spec').prop('checked', true);
        } else {
          $('input.' + name + '_spec').prop('checked', false);
        }
      },
      toggleAll(name, value = null) {
        this.toggle(name, value)
        this.toggleRadio(name, value)
      },
      backToResults() {
        localStorage.setItem('came-from-order', 'true')
        this.axios.delete('orders/' + this.order.id).then(response => {
          this.$router.push({name: 'results.index', params: {quote_id: this.order.quote.uniqid}})
        }).catch(err => {
          console.log(err)
        })
      },
      submitOrder() {
        if (!this.isChecked(this.terms_and_agreement)) return alert('You must agree to terms and agreement')
        this.axios.put('orders/' + this.order.id, this.getContacts()).then(response => {
          this.$router.push({name: 'orders.success'})
//          alert('Order updated')
        }).catch(err => {
          console.log(err)
          alert('Error occoured!')
        })
      },


      //copy
      getSwitchAndSaveValue(years = -1) {
        let value;
        if (years === -1) {
          value = this.order.costs.switch_and_save.purchase;
        } else {
          value = this.order.costs.switch_and_save.lease[years];
        }
        if (value) {
          value = value.toFixed(2)
        }
        return value ? value : '-';
      },
      // getTotalEffectiveCostValue(years = -1) {
      //   let value;
      //   if (years === -1) {
      //     value = this.order.costs.total_effective_cost.purchase;
      //   } else {
      //     value = this.order.costs.total_effective_cost.lease[years];
      //   }
      //   if (value) {
      //     value = value.toFixed(2)
      //   }
      //   return value ? value : '-';
      // },

      getPostageSavingsOverTermValue(years = -1) {
        let value;
        if (years === -1) {
          value = this.order.costs.postage_savings_over_term.purchase;
        } else {
          value = this.order.costs.postage_savings_over_term.lease[years];
        }
        if (value) {
          value = value.toFixed(2)
        }
        return value ? value : '-';
      },

      getTotalEffectiveCostValue(years = -1) {
        let value;
        if (years === -1) {
          // Purchase

          // If franking user, pull from C64 (total_cost_future_ownership). Else use C52 (total_equipment_and_service_cost)
          if (this.order.quote.uses_franking_machine) {
            // Franking machine YES
            if (this.order.costs.annual_savings_available.purchase < 0) { // C54 is NEGATIVE
              value = this.order.costs.total_equipment_and_service_cost.purchase // use C52
            } else {
              value = this.order.costs.total_cost_future_ownership.purchase // use C64
            }
          } else {
            // Franking machine NO
            value = this.order.costs.total_equipment_and_service_cost.purchase
          }

        } else {
          // Lease

          // If franking user, pull from C64 (total_cost_future_ownership). Else use C52 (total_equipment_and_service_cost)
          if (this.order.quote.uses_franking_machine) {
            // Franking machine YES
            if (this.order.costs.annual_savings_available.lease[years] < 0) { // C54 is NEGATIVE
              value = this.order.costs.total_equipment_and_service_cost.lease[years] // use C52
            } else {
              value = this.order.costs.total_cost_future_ownership.lease[years] // use C64
            }
          } else {
            // Franking machine NO
            value = this.order.costs.total_equipment_and_service_cost.lease[years] // use C52
          }
        }
        if (value) {
          value = value.toFixed(2)
        }
        return value ? value : 0;
      },
      getSavingOverTermValue(years = -1) {
        let value;
        if (years === -1) {
          value = this.order.costs.savings_over_term.purchase;
        } else {
          value = this.order.costs.savings_over_term.lease[years];
        }
        if (value) {
          value = value.toFixed(2)
        }
        return value ? value : '-';

      },
      getEffectiveAnnualSaving(years = -1) {
        let value;
        if (years === -1) {
          value = this.order.costs.annual_savings_available.purchase;
        } else {
          value = this.order.costs.annual_savings_available.lease[years];
        }
        if (value) {
          value = value.toFixed(2)
        }
        return value ? value : '-';
      },



      updateContactPreferences() {
        if (Object.keys(this.step2).length !== 0) {
          this.contact_by_email = this.preferences_email
          this.contact_by_phone = this.preferences_phone
          this.contact_by_post = this.preferences_mail
          this.contact_by_sms = this.preferences_sms
          this.$forceUpdate()
        }
      }

    }
  }
</script>
<style lang="scss">

  .regular-para {
    font-size: 1.4rem;
    line-height: 1.4;
    text-align: center;
    margin-top: 15px;
  }

  .specification-summary hr {
    color: #d3d3d3;
  }

  .box.order-details {
    border: 2px solid #d3d3d3;
    padding: 20px;
  }

  .box.specification-summary .border {
    border: 2px solid #d3d3d3;
    padding: 20px;
  }

  .box.specification-summary {
    padding: 0 40px !important;
  }

  .row {
    display: flex;
  }

  .box {
    width: 50%;
    margin-top: 20px;
    h3 {
      margin-bottom: 35px;
      color: #0a70e3;
      font-weight: 700;
      font-size: 1.8rem;
      text-align: center;
    }
    &.specification-summary {
      padding: 20px;
      .btn:first-child {
        width: 100%;
        text-align: center;
        margin-bottom: 20px;
      }
      h5 {
        font-size: 1.4rem;;
        text-align: center;
        margin-top: 20px;
        font-weight: 500;
      }
    }
    &.order-details {
      h4 {
        text-align: center;
        color: #767777;

        &.text-red {
          color: #b50a78;
        }
        &.text-blue {
          color: #2772dd;
        }
      }
      p.small {
        color: #363636;
        font-size: 1.4rem;
        margin-top: 10px;
      }
      .mt3 {
        margin-top: 50px !important;
      }

    }
    &.machine-details {
      padding-right: 40px;
      padding-left: 40px;
      .machine-image {
        border: 2px solid #d3d3d3;
        width: 100%;
        padding: 20px;
        img {
          display: block;
          margin: 0 auto;
          width: 100%;
          height: auto;
          max-width: 400px;
        }
      }
    }
    &.your-details {
      border: 2px solid #d3d3d3;
      padding: 20px;
      table {
        width: 100%;
        table-layout: fixed;
        overflow-wrap: break-word;
        th {
          padding-right: 20px;
          width: 200px;
          text-align: right;
          line-height: 1.5;
          font-size: 18px;
          width: 40%
        }
        td {
          text-align: left;
          font-size: 18px;
          color: #363636 !important;
          line-height: 1.5;
          padding: 10px;

          &:first-child {
            width: 150px;
            padding-right: 20px;
          }
        }
      }
    }
  }

  .btn.btn-gradient {
    background: linear-gradient(45deg, #0a70e3 0%, #f81e8c 100%);
    color: white;
    width: auto !important;
    border-radius: 0;
    cursor: pointer;

    border-radius: .3125rem;
    font-size: 1.65625rem;
    padding: 1.25rem 2.6rem;
    text-align: center;
    box-shadow: 0px 4px 22.56px 1.44px rgba(0, 0, 0, 0.3);

  }

  .frmInline {
    text-align: center;
  }

  .specification-summary .frmInline input[type="radio"],
  .specification-summary .frmInline input[type="checkbox"] {
    background-color: #cdcdcd !important;
  }

  .frmInline input[type="checkbox"] {
    display: inline-block;
    background-color: #fff;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    vertical-align: middle;
    height: 30px;
    width: 30px;
  }

  .frmInline input[type="checkbox"]:checked {
    background-image: url(/static/styles/mailkit/img/tick_selected.png);
    background-repeat: no-repeat;
    background-position: center;
  }

  .mb-200 {
    margin-bottom: 200px;
  }

  p.small {
    text-align: center;
    line-height: 1.5;

    a {
      color: #000;
    }
  }

</style>

<style scoped lang="scss">
  .fullText > .in {
    width: 100%;
    max-width: 75rem;
  }

  .frmInline {
    span {
      display: block;
      margin-top: 5px;
    }

    .agreementWrapper span {
      display: inline;
      margin: 0;
    }
  }

  @media screen and (max-width: 1023px) {
    .row {
      display: block;
    }

    .box.specification-summary {
      padding: 0 !important;
    }

    .box.your-details,
    .box.machine-details,
    .box.order-details,
    .box.specification-summary {
      width: 100% !important;
    }

    .box.machine-details {
      padding-left: 0;
      padding-right: 0;

      .machine-image {
        border-width: 2px;
      }
    }

    .frmInline {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start !important;

      > div {
        flex: 1;
        margin: 5px 0;
      }

      .agreementWrapper {
        display: flex;
        align-items: center;

        input {
          flex: 0 0 30px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Order/Index.vue